import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-arteh-list-view',
  imports: [],
  templateUrl: './arteh.list-view.html',
  styleUrls: ['./arteh.list-view.css'],
})
export class ArtehListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
